var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "portfolio-benchmark az-card-bordered",
      class: { "portfolio-benchmark--loading": _vm.loading }
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "portfolio-benchmark__header" }, [
            _c(
              "div",
              { staticClass: "portfolio-benchmark__title az-ds-card-title" },
              [_vm._v(" Portfólio e Benchmark ")]
            ),
            _c("div", { staticClass: "portfolio-benchmark__actions" }, [
              _c(
                "div",
                { staticClass: "portfolio-benchmark__actions-left" },
                [_vm._t("actions-left")],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "portfolio-benchmark__actions-right",
                  class: {
                    "portfolio-benchmark__actions-right--compact":
                      _vm.hideBenchmarks
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "portfolio-benchmark__action-rentabilidade"
                    },
                    [
                      _c(
                        "BaseButton",
                        {
                          attrs: { secondary: "", text: "", sm: "" },
                          on: {
                            click: function($event) {
                              return _vm.onShowAllGroups(!_vm.showAllGroups)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: _vm.showAllGroups
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline",
                              size: 16,
                              color: "primary"
                            }
                          }),
                          _vm._v(" Mostrar todos os grupos ")
                        ],
                        1
                      ),
                      !_vm.hideBenchmarks
                        ? _c("BenchmarksMenu", {
                            attrs: {
                              benchmarks: _vm.benchmarks,
                              "cliente-benchmark-meta":
                                _vm.clienteBenchmarkMeta,
                              "available-benchmark-names":
                                _vm.availableBenchmarkNames,
                              "show-add-benchmark": _vm.showAddBenchmark
                            },
                            on: {
                              change: function($event) {
                                return _vm.$emit("change")
                              },
                              "add-benchmark": function($event) {
                                return _vm.$emit("add-benchmark")
                              },
                              reset: function($event) {
                                return _vm.$emit("reset")
                              }
                            },
                            model: {
                              value: _vm.selectedBenchmarksProxy,
                              callback: function($$v) {
                                _vm.selectedBenchmarksProxy = $$v
                              },
                              expression: "selectedBenchmarksProxy"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._t("actions-right")
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _c(
        "FeedbackWrapper",
        {
          attrs: {
            loading: _vm.loading,
            noData: _vm.hasNoData,
            message: _vm.emptyMessage
          }
        },
        [
          _c(
            "div",
            { staticClass: "portfolio-benchmark__content" },
            [_c("RentabilidadeChart", { attrs: { data: _vm.displayedData } })],
            1
          )
        ]
      ),
      !_vm.loading ? _vm._t("footer") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }